import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLocationApi } from "../../apiservice/setting";
import { deleteLocationApi } from "../../apiservice/accounts";
import { SaveLocationApi } from "../../apiservice/sales";

export const fetchLocationsList = createAsyncThunk(
  "locations/fetchLocationsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLocationApi(null);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createOrUpdateLocation = createAsyncThunk(
  "locations/createOrUpdateLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await SaveLocationApi(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteLocation = createAsyncThunk(
  "locations/deleteLocation",
  async (location_id, { rejectWithValue }) => {
    try {
      const res = await deleteLocationApi({ location_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
